import { Box } from '@mui/material';
import CheckBox from '@root/components/v2/ui-elements/CheckBox';
import { useMemo } from 'react';
import Tooltip from '../../ui-elements/Tooltip';
import azure_icon from '@root/assets/img/cloud_provider_icons/azure_small_icon.png';
// import GCPIcon from '@root/assets/img/header/cloud_providers/gcp.png';
import aws_light from '@root/assets/img/complainceFamilyIcons/AWS SVG.svg';
import gcp_well from '@root/assets/img/complainceFamilyIcons/GCP-Well-Architected_v2020-07-02.svg';
import './EnvironmentDropdown.scss';
// import { useEnvironments } from '@root/hooks/environments';
import Text from '../../ui-elements/Text';

const EnvironmentDropdownOption = ({
  options,
  // index,
  // length,
  handleOptionClick,
  // handleGroupClick,
  disabledOptions,
  value,
  cloudProvider,
}) => {
  // const [open, setOpen] = useState(true);
  // const [delayedOpen, setDelayedOpen] = useState(true);
  // const environments = useEnvironments();

  // useEffect(() => {
  //   if (!open) {
  //     setTimeout(() => {
  //       setDelayedOpen(open);
  //     }, 200);
  //   } else {
  //     setDelayedOpen(open);
  //   }
  // }, [open]);

  // const allChildrenSelected = useMemo(() => {
  //   if (option.options) {
  //     let temp = true;

  //     option.options.forEach(child => {
  //       if (!value.includes(child.value)) temp = false;
  //     });

  //     return temp;
  //   }
  // }, [option.options, value]);
  // // console.log(option, value, 'xvkxv');
  // const selectedCloudProvider = useMemo(() => {
  //   const cpMapping = { GCP: 0, AWS: 0, AZURE: 0 };
  //   const gcpAccount = environments.filter(env => env.cloudProvider === 'gcp')?.map(env => env.id);
  //   const awsAccount = environments.filter(env => env.cloudProvider === 'aws')?.map(env => env.id);
  //   const azureAccount = environments.filter(env => env.cloudProvider === 'azure')?.map(env => env.id);

  //   for (let index = 0; index < value.length; index++) {
  //     if (gcpAccount.includes(value[index])) {
  //       cpMapping['GCP'] += 1;
  //     }
  //     if (awsAccount.includes(value[index])) {
  //       cpMapping['AWS'] += 1;
  //     }
  //     if (azureAccount.includes(value[index])) {
  //       cpMapping['AZURE'] += 1;
  //     }
  //   }

  //   return cpMapping;
  // }, [environments, value]);
  // console.log(selectedCloudProvider, option, 'selectedCloudProvider');

  const environmentList = useMemo(() => {
    if (cloudProvider === 'all') {
      let allEnvs = [];
      for (const option of options) {
        if (Array.isArray(option.options)) {
          allEnvs.push(...option.options);
        }
      }
      return allEnvs;
    } else {
      const matched = options.find(option => option.label?.toLowerCase() === cloudProvider);
      return matched && Array.isArray(matched.options) ? [...matched.options] : [];
    }
  }, [cloudProvider, options]);

  return (
    <>
      <div style={{ display: 'flex' }}>
        {/* <Box className="EnvironmentDropdown__Option" onClick={() => handleGroupClick(option)}>
          <CheckBox checked={allChildrenSelected} style={{ padding: '0px' }} />
          <div>
            <img
              src={option.icon}
              style={{ width: option.label === 'AWS' ? '25px' : '20px', marginRight: '7px', marginLeft: '5px' }}
            />
          </div>
          <div style={{ marginLeft: '2px' }}>({selectedCloudProvider[option.label]})</div>
          <div style={{ flexGrow: '1' }} />
        </Box> */}
      </div>
      {environmentList && (
        <Box
          className="EnvironmentDropdown__ChildOptions"
          style={{
            // height: open ? `${option.options.length * 43}px` : '0px',
            display: open ? 'block' : 'none',
            borderTop: open ? '1px solid var(--boder-line-light, #cbd5e0)' : 'none',
          }}>
          {environmentList &&
            environmentList.map(child => {
              //default case

              return (
                <Box
                  className="EnvironmentDropdown__ChildOption"
                  onClick={disabledOptions.includes(child.value) ? null : () => handleOptionClick(child)}>
                  <div style={{ width: '100%' }} className="flex align-items-center gap-[4px]">
                    <img
                      src={
                        child.data.cloudProvider === 'aws'
                          ? aws_light
                          : child.data.cloudProvider === 'gcp'
                          ? gcp_well
                          : child.data.cloudProvider === 'azure'
                          ? azure_icon
                          : ''
                      }
                      style={{ width: child.label === 'AWS' ? '25px' : '20px', marginRight: '7px', marginLeft: '5px' }}
                    />
                    <Tooltip title={`${child.label}(${child?.data?.environment_name})`} isIcon={true}>
                      {' '}
                      <Text style={{ maxWidth: '160px' }} className="SingleLine">
                        {child.label}
                      </Text>
                    </Tooltip>
                  </div>

                  {/* <div style={{ flexGrow: '1' }} /> */}
                  <CheckBox checked={value.includes(child.value)} style={{ padding: '0px' }} />
                </Box>
              );
            })}
        </Box>
      )}
    </>
  );
};

export default EnvironmentDropdownOption;
